import React, { useState } from "react";
import Button from "../../components/controls/Button";
import Form from "../../components/Form/Form";
import useForm from "../../components/Form/useForm";
import Spinner from "../../components/Spinner/Spinner";
import { passwordValidator } from "../../utils/validators";
import TextField from '@mui/material/TextField';
import { FormHelperText } from "@mui/material";



const fields = [
  {
    field: "code",
    headerName: "Código de verificación",
    type: "number"
  },
  {
    field: "password",
    headerName: "Nueva contraseña",
    type: "password",
    validation: passwordValidator,
  },
];


const initialValues = Object.assign(
  ...fields.map((x) => ({ [x.field]: x.value || "" }))
);

const ForgotPasswordForm = ({ addOrEdit, loading, setLoading }) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});


  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    fields.forEach((value) => {
      if (value.field in fieldValues && value.validation)
        temp[value.field] = value.validation(fieldValues[value.field]);
    });
    setErrors({
      ...temp,
    });
    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { handleInputChange } = useForm(
    initialValues,
    validate,
    true,
    null,
    values,
    setValues,
    errors,
    setErrors,
  );

  const handleSubmit = () => {
    if (validate()) {
      setLoading(true);
      addOrEdit(values);
    }

  };

  const renderFields = (begin, end) => {
    return fields
      .slice(begin, end)
      .map((value) => (
        <div className="d-flex d-inline justify-content-center col-12">
          <TextField
            className="textfield-update"
            type={value.type || ""}
            key={value.field}
            label={value.headerName}
            name={value.field}
            value={
              values[value.field] == null ? "" : values[value.field].toString()
            }
            onChange={handleInputChange}
            error={errors[value.field]}
          />

        </div>
      ));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="container">
          <div className="col-12 col-xl-12">
            <div className="mt-3 mb-3 text-update">
              <span>
                Introduce el código que hemos enviado a tu correo electrónico para crear una nueva contraseña.
                En caso de no encontrarlo, revisa también la carpeta de <span className="comfirm-help-text-purple">correo no deseado</span> o de <span className="comfirm-help-text-purple">spam</span>.
              </span>
              
            </div>

            <div>{renderFields(0, fields.length)}
              <div className="mt-3 mb-3 text-update">
                <FormHelperText id="component-helper-text"> La contraseña debe contener entre 8 y 50 caracteres, incluyendo una
                  letra mayúscula, una letra minúscula y un número y símbolo
                </FormHelperText>
              </div>
            </div>
            <div className="mt-3 d-flex d-inline justify-content-center">
              {loading ? (
                <Spinner />
              ) : (
                <>
                  <Button
                    className="button-update"
                    type="submit"
                    text="Actualizar"
                  />
                </>
              )}

            </div>
       
          </div>
        </div>
      </Form>

    </>
  );
};

export default ForgotPasswordForm;
